<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-dialog class="CustomersForm" :title="title" :visible.sync="addCustomersDialog" width="55%"
                    @click="closeDialog()">
                    <div>
                        <el-form :inline="true" :model="formInline" ref="formInline" class="user-search" size="small"
                            :rules="$rules">
                            <el-form-item label="企业名称：" prop="customersName">
                                <el-input size="small" v-model="formInline.customersName" placeholder="请输入企业名称">
                                </el-input>
                            </el-form-item>

                            <br />

                            <el-form-item label="企业云ID:" prop="customersID">
                                <el-input size="small" v-model="formInline.customersID" placeholder="请输入企业云ID"
                                    @blur="customersIDBlur(formInline.customersID)" style="width: 145px;">
                                </el-input>

                                <el-button type="primary" size="small" @click="getCloudID()"
                                    style="float: right;padding: 6px 8px;margin-top: 3px;">
                                    <i class="el-icon-circle-plus-outline"></i></el-button>

                            </el-form-item>
                            <el-form-item label="登录账号：" prop="loginID">
                                <el-input size="small" v-model="formInline.loginID" placeholder="请输入登录账号"
                                    @blur="loginIDBlur(formInline.loginID)">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="登录密码：" prop="loginPsw">
                                <el-input size="small" v-model="formInline.loginPsw" placeholder="请输入登录密码">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="账号类型：" prop="accountType">
                                <el-select size="small" placeholder="请选择账号类型" v-model="formInline.accountType">
                                    <el-option v-for="item in accountType" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="账号权限：" prop="accountPermissions">
                                <el-select size="small" placeholder="请选择账号权限" v-model="formInline.accountPermissions">
                                    <el-option v-for="item in accountPermissions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="空间大小(M)：" prop="space">
                                <el-input type="number" size="small" v-model="formInline.space" placeholder="请输入空间大小">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="用户数量：" prop="userNum">
                                <el-input type="number" size="small" v-model="formInline.userNum" placeholder="请输入用户数量">
                                </el-input>
                            </el-form-item>


                            <el-form-item label="有效期：" prop="startDate">
                                <el-date-picker v-model="formInline.startDate" type="datetime" :clearable="false"
                                    placeholder="选择有效期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="备注:" prop="remarks">
                                <el-input size="small" v-model="formInline.remarks" placeholder="请输入备注">
                                </el-input>
                            </el-form-item>

                            <br />

                            <el-form-item label="" prop="QRCodeWeight" class="checkboxItem">
                                <el-checkbox v-model="formInline.QRCodeWeight" true-label="1"
                                    false-label="0">启用二维码过磅功能</el-checkbox>
                            </el-form-item>

                            <el-form-item label="" prop="appointmentWeight" class="checkboxItem">
                                <el-checkbox v-model="formInline.appointmentWeight" true-label="1"
                                    false-label="0">启用预约过磅功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="backendReview" class="checkboxItem">
                                <el-checkbox v-model="formInline.backendReview" true-label="1"
                                    false-label="0">启用预约后台审核功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="basicInformation" class="checkboxItem">
                                <el-checkbox v-model="formInline.basicInformation" true-label="1"
                                    false-label="0">启用云端基础信息修改功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="remoteRecharge" class="checkboxItem">
                                <el-checkbox v-model="formInline.remoteRecharge" true-label="1"
                                    false-label="0">启用远程充值功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="remoteModification" class="checkboxItem">
                                <el-checkbox v-model="formInline.remoteModification" true-label="1"
                                    false-label="0">启用远程修改数据功能</el-checkbox>
                            </el-form-item>
                            <el-form-item label="" prop="dataView" class="checkboxItem">
                                <el-checkbox v-model="formInline.dataView" true-label="1"
                                    false-label="0">启用集团版数据查看功能</el-checkbox>
                            </el-form-item>

                            <el-form-item label="" prop="WxApplyManage" class="checkboxItem">
                                <el-checkbox v-model="formInline.WxApplyManage" true-label="1"
                                    false-label="0">小程序预约自定义</el-checkbox>
                            </el-form-item>





                        </el-form>

                        <div class="buttonClick">
                            <span slot="footer" class="dialog-footer" style="float: right;margin: 10px ;">
                                <el-button size="small" @click="closeDialog('formInline')">关 闭</el-button>
                                <el-button size="small" type="primary" @click="save('formInline')">保 存</el-button>
                            </span>
                        </div>

                    </div>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
// 导入请求方法
import { getMaxCloudID, newCustomer } from "../../api/userMG";
export default {
    data() {
        return {
            addCustomersDialog: false,
            title: "",
            formInline: {
                customersName: "",
                customersID: "",
                loginID: "",
                loginPsw: "123",
                accountType: "云用户",
                accountTypeID: "1",
                accountPermissions: "管理员",
                accountPermissionsID: "1",
                space: "1024",
                userNum: "5",
                startDate: "",
                QRCodeWeight: "0",
                appointmentWeight: "0",
                backendReview: "0",
                basicInformation: "0",
                remoteRecharge: "0",
                remoteModification: "0",
                dataView: "0",
                WxApplyManage: "0",
                remarks: "",
            },
            accountType: [
                {
                    label: "云用户",
                    value: "1",
                },
                {
                    label: "装卸货确认",
                    value: "2",
                },
            ],
            accountPermissions: [
                {
                    label: "管理员",
                    value: "1",
                },
                {
                    label: "普通用户",
                    value: "2",
                },
            ]
        };
    },
    methods: {
        isDialog(index, title) {
            let that = this;
            that.addCustomersDialog = index;
            that.title = title;
            that.formInline.startDate = that.$utils.oneYearLater();
        },
        getCloudID() {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            let param = {
                'timeStamp': timestamp,
                "adUser": that.$store.state.adminLoginName,
            };
            getMaxCloudID(param).then((res) => {
                if (res.data.code == 200) {
                    that.formInline.customersID = res.data.result;
                    that.formInline.loginID = res.data.result;
                }
            });
        },
        // 保存
        save(formName) {
            let that = this;
            let timestamp = Math.floor(Date.now() / 1000);
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        "企业名称": that.formInline.customersName,
                        "企业云ID": that.formInline.customersID,
                        "登录账号": that.formInline.loginID,
                        "登录密码": that.formInline.loginPsw,
                        "账号类型": that.formInline.accountType,
                        "账号类型ID": that.formInline.accountTypeID,
                        "账号权限": that.formInline.accountPermissions,
                        "账号权限ID": that.formInline.accountPermissionsID,
                        "空间大小": that.formInline.space,
                        "用户数量": that.formInline.userNum,
                        "有效期": that.formInline.startDate,
                        "启用二维码过磅功能": that.formInline.QRCodeWeight,
                        "启用预约过磅功能": that.formInline.appointmentWeight,
                        "启用预约后台审核功能": that.formInline.backendReview,
                        "启用云端基础信息修改功能": that.formInline.basicInformation,
                        "启用远程充值功能": that.formInline.remoteRecharge,
                        "启用远程修改数据功能": that.formInline.remoteModification,
                        "启用集团版数据查看功能": that.formInline.dataView,
                        "小程序预约自定义": that.formInline.WxApplyManage,
                        "备注": that.formInline.remarks,
                        "adUser": that.$store.state.adminLoginName,
                        "timeStamp": timestamp
                    }

                    newCustomer(params).then((res) => {
                        if (res.data.code == 200) {
                            that.$message({
                                type: "success",
                                message: res.data.message,
                            });
                            that.$emit('reset', true);
                            that.closeDialog(formName);

                        } else {
                            that.$message({
                                type: "error",
                                message: res.data.message,
                            });
                        }
                    });


                }
            })

        },

        // 企业云ID失焦后给登录账号赋值
        customersIDBlur(val) {
            this.formInline.loginID = val
        },

        // 登录账号失焦后给企业云ID赋值

        loginIDBlur(val) {
            this.formInline.customersID = val
        },



        // 关闭编辑、增加弹出框
        closeDialog(formName) {
            this.$refs[formName].resetFields();
            this.addCustomersDialog = false;
        },
    },
};
</script>
<style lang="less" scoped>
.el-form-item {
    width: 31%;
    margin: 7px 0;

    /deep/ .el-form-item__label {
        width: 120px;
    }

    /deep/ .el-form-item__content {
        width: 180px;

        .el-date-editor {
            width: 180px;

        }

    }
}

.checkboxItem {

    /deep/ .el-form-item__content {
        margin-left: 80px;
    }

}
</style>


// WEBPACK FOOTER //
// src/views/admin666/addCustomers.vue